import '~/assets/scss/bpif.scss'

import PageProduct from '~/js/modules/page-product';
import getSwiperSlider from '~/js/modules/slider';
import Pikaday from "pikaday"
import '~/js/modules/linked-funds'
import '~/js/modules/funds-year-replace'

// import '~/js/modules/switches';
import '~/js/modules/tabs';
import SwitchStock from '~/js/modules/switch-stock';

new PageProduct();
window.addEventListener(`DOMContentLoaded`, () => {

  const productsSlider = document.querySelector(`.products__slider`);
  const productsSliderMobile = document.querySelector(`.products__slider-mobile`);
  let productsSwiper;
  let productsSwiperMobile;

  const productsSwiperParams = {
    slidesPerView: `auto`,
    loop: false,
    autoplay: false,
    pagination: false,
  };

  if (productsSlider) {
    productsSwiper = getSwiperSlider(productsSlider, productsSwiperParams);
  }

  if (productsSliderMobile) {
    productsSwiperMobile = getSwiperSlider(productsSliderMobile, productsSwiperParams);
  }

  let elem = document.querySelectorAll('.js-pie-chart-datepicker');
  if (elem) {
    elem.forEach((el) => {
      let min = new Date(el.dataset.min);
      let max = new Date();
      let picker = new Pikaday({
        field: el,
        keyboardInput: false,
        minDate: min,
        maxDate: max,
        format: 'DD.MM.YYYY',
        toString(date, format) {
          let day = date.getDate();
          if (day < 10) {
            day = '0' + day;
          }
          let month = date.getMonth() + 1;
          if (month < 10) {
            month = '0' + month;
          }
          let year = date.getFullYear();
          return year + '-' + month + '-' + day;
        },
        parse(dateString, format) {
          const parts = dateString.split('/');
          const day = parseInt(parts[0], 10);
          const month = parseInt(parts[1] - 1, 10);
          const year = parseInt(parts[1], 10);
          return new Date(year, month, day);
        },
        i18n: {
          previousMonth: 'Предыдущий месяц',
          nextMonth: 'Следующий месяц',
          months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
          weekdays: ['Воскресерье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
          weekdaysShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
        },
      });
    })
  }

  const stock = document.querySelectorAll(`.js-stocks-container`);

  if (stock) {
    new SwitchStock({ container: 'stocksA', mode: 'slider' });
  }

  const isinCopyBtns = document.querySelectorAll(`.js-isin-copy`)
  if (isinCopyBtns) {
    isinCopyBtns.forEach((x) => {
      x.addEventListener('click', function () {
        let text = x.innerHTML;
        let copyhelper = document.createElement("input");
        document.body.appendChild(copyhelper);
        copyhelper.value = text;
        copyhelper.select();
        document.execCommand("copy");
        document.body.removeChild(copyhelper);
      })
    })
  }
})
